import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const FooterPrice = styled(Text)`
  color: #040222;
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
  position: relative;
  margin-left: 10px;
  span {
    color: #5b5675;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  ::before {
    position: absolute;
    content: "₹";
    left: -10px;
    top: 2px;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    color: #040222;
  }
`;

export const FooterText = styled(Text)`
  color: #1b73e8;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  ${(props: { wrapperStyles: any }) => props.wrapperStyles}
`;
